import script from "./MenuList.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuList.vue?vue&type=script&setup=true&lang=js"

import "./MenuList.vue?vue&type=style&index=0&id=4c52bf79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c52bf79"]])

export default __exports__